import * as React from "react";
import {
  useNavigate,
  useParams,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import Title from "../Common/Title";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Breadcrumbs,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  Link,
  Select,
  TextField,
  Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { formatDate, formatDateTime } from "../../Utils/util-service";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  getVendorByVendorID,
  getEstimateByEstimateID,
  updateEstimateByEstimateID,
  postProductToEstimateAgain,
} from "../../Utils/vendor-customer-service";
import EstimateTable from "./EstimateTable";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import AddToPhotosIcon from "@mui/icons-material/AddToPhotos";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { CHANGE_STATUSES } from "../../Utils/constant";
import SearchAutoComplete from "../ProductSearch/SearchAutoComplete";
import ProductSelection from "../ProductSearch/ProductSelection";
import LineLoading from "../Common/LineLoading";

export default function EstimateDetail() {
  const [vendor, setVendor] = React.useState();
  const [estimate, setEstimate] = React.useState();
  const { vendorID, estimateId } = useParams();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [selectedIndex, setSelectedIndex] = React.useState();
  const [selectedProduct, setSelectedProduct] = React.useState();
  const [selectedStatus, setSelectedStatus] = React.useState();

  const [openChangeQty, setOpenChangeQty] = React.useState(false);
  const [openDeleteProduct, setOpenDeleteProduct] = React.useState(false);
  const [openStatusConfirm, setOpenStatusConfirm] = React.useState(false);
  const [openAddProduct, setOpenAddProduct] = React.useState(false);
  const [fetchAgain, setFetachAgain] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const [fulloading, setFulloading] = React.useState(false);

  const [searchedProduct, setSearchedProduct] = React.useState();
  const handleClickOpenChangeQty = () => {
    setOpenChangeQty(true);
  };

  const handleCloseChangeQty = () => {
    setOpenChangeQty(false);
  };

  const handleCloseDeleteProduct = () => {
    setOpenDeleteProduct(false);
  };

  const handleCloseStatusConfirmBox = () => {
    setOpenStatusConfirm(false);
  };

  const handleAddProductClose = () => {
    setOpenAddProduct(false);
  };
  const navigate = useNavigate();
  // Handle browser back button and ensure state is preserved
  React.useEffect(() => {
    const handleBeforeUnload = () => {
      // Store current state in sessionStorage as fallback
      const currentState = {
        tab: searchParams.get("returnTab") || location.state?.tab || 0,
        page: searchParams.get("returnPage") || location.state?.page || 0,
        pageSize:
          searchParams.get("returnPageSize") || location.state?.pageSize || 25,
        status:
          searchParams.get("returnStatus") || location.state?.status || "NEW",
      };
      sessionStorage.setItem(
        "estimateReturnState",
        JSON.stringify(currentState)
      );
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [searchParams, location.state]);

  React.useEffect(() => {
    if (vendorID) {
      fetchVendorDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendorID]);

  const fetchVendorDetails = () => {
    setFulloading(true);
    return getVendorByVendorID(vendorID).then((res) => {
      if (res?.data) {
        setFulloading(false);
        setVendor(res?.data);
      }
    });
  };

  React.useEffect(() => {
    if (estimateId) {
      fetchEstimateDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estimateId, fetchAgain]);

  const fetchEstimateDetails = () => {
    return getEstimateByEstimateID(estimateId).then((res) => {
      if (res?.data) {
        setEstimate(res?.data);
      }
    });
  };

  const updateEstimateDetail = (obj) => {
    setLoading(true);
    return updateEstimateByEstimateID(estimateId, obj).then((response) => {
      if (response?.status === 204) {
        setFetachAgain(new Date().getTime());
        handleCloseDeleteProduct();
        handleCloseStatusConfirmBox();
        handleAddProductClose();
        handleCloseChangeQty();
        setLoading(false);
      }
    });
  };

  const addProductToEstimateAgain = () => {
    const esti = estimate;
    const obj = {
      vendorID: esti.vendorID,
      productIds: esti?.cart?.map((product) => product.id),
    };
    return postProductToEstimateAgain(obj).then((response) => {
      return null;
    });
  };

  const handleClick = (event) => {
    event.preventDefault();
    console.info("You clicked a breadcrumb.");
  };

  const handlePrint = (event, onlyItems) => {
    const isShowItem = onlyItems ? "1" : "0";
    window
      .open(
        "http://estimate395.com/v1/admin/estimate-report/" +
          estimateId +
          "?isShowItem=" +
          isShowItem,
        "_blank"
      )
      .focus();
    event.preventDefault();
  };

  const handleDeleteProduct = (product, index) => {
    console.info("handleDeleteProduct", product, index);
    setSelectedProduct(product);
    setSelectedIndex(index);
    setOpenDeleteProduct(true);
  };

  const handleChangeQuantity = (product, index) => {
    console.info("You clicked a breadcrumb.", product, index);
    setSelectedProduct(product);
    setOpenChangeQty(true);
    setSelectedIndex(index);
  };

  const handleProductChangeQty = () => {
    const esti = estimate;
    // Deducting old product quantity price from total estimate price
    esti.totalAmount =
      esti?.totalAmount - esti?.cart[selectedIndex]?.totalPrice;

    // now, adding new product quantity price to total estimate price
    esti.totalAmount = esti?.totalAmount + selectedProduct?.totalPrice;
    esti.cart[selectedIndex] = selectedProduct;
    // console.log(esti);
    // console.log(selectedProduct, selectedIndex);
    updateEstimateDetail(esti);
  };

  const handleDeletionOfProduct = () => {
    const esti = estimate;
    esti.cart.splice(selectedIndex, 1);
    esti.totalAmount = esti?.totalAmount - selectedProduct?.totalPrice;
    esti.totalQuantity -= 1;
    updateEstimateDetail(esti);
  };

  // change status functions
  const handleStatusChange = (status) => {
    if (estimate.status === status) {
      return;
    }

    // For NEW to INPROGRESS, no confirmation needed
    if (estimate.status === "NEW" && status === "INPROGRESS") {
      const esti = estimate;
      esti.status = status;
      updateEstimateDetail(esti);
      return;
    }

    // For INPROGRESS to COMPLETED or CANCELLED, show confirmation
    if (
      estimate.status === "INPROGRESS" &&
      (status === "COMPLETED" || status === "CANCELLED")
    ) {
      setSelectedStatus(status);
      setOpenStatusConfirm(true);
      return;
    }

    // For other status changes, show confirmation
    setSelectedStatus(status);
    setOpenStatusConfirm(true);
  };

  const handleConfirmStatusChange = () => {
    if (estimate.status === selectedStatus) {
      return;
    }
    const esti = estimate;
    esti.status = selectedStatus;
    updateEstimateDetail(esti);
    // COMPLETED
    if (selectedStatus === "COMPLETED") {
      addProductToEstimateAgain();
    }
  };

  const getProductFromAutoComplete = (product) => {
    setSearchedProduct(product?.id);
  };

  const addProductToCart = (product) => {
    const esti = estimate;
    esti.cart.push(product);
    esti.totalAmount = esti?.totalAmount + product?.totalPrice;
    esti.totalQuantity += 1;
    updateEstimateDetail(esti);
  };
  //

  const breadCrums = () => {
    // Get return parameters from URL, location state, or sessionStorage
    const getReturnState = () => {
      // Check URL params first
      const urlTab = searchParams.get("returnTab");
      const urlPage = searchParams.get("returnPage");
      const urlPageSize = searchParams.get("returnPageSize");
      const urlStatus = searchParams.get("returnStatus");

      // Check location state
      const stateTab = location.state?.tab;
      const statePage = location.state?.page;
      const statePageSize = location.state?.pageSize;
      const stateStatus = location.state?.status;

      // Check sessionStorage as fallback
      let sessionState = null;
      try {
        const stored = sessionStorage.getItem("estimateReturnState");
        if (stored) {
          sessionState = JSON.parse(stored);
        }
      } catch (e) {
        console.warn("Failed to parse sessionStorage state:", e);
      }

      return {
        tab: urlTab || stateTab || sessionState?.tab || 0,
        page: urlPage || statePage || sessionState?.page || 0,
        pageSize: urlPageSize || statePageSize || sessionState?.pageSize || 25,
        status: urlStatus || stateStatus || sessionState?.status || "NEW",
      };
    };

    const returnState = getReturnState();

    const handleBackNavigation = () => {
      // Navigate back to estimates page with preserved state
      navigate(
        `/?tab=${returnState.tab}&page=${returnState.page}&pageSize=${returnState.pageSize}`,
        {
          state: {
            tab: returnState.tab,
            page: returnState.page,
            pageSize: returnState.pageSize,
            status: returnState.status,
          },
        }
      );
    };

    return (
      <div role="presentation" onClick={handleClick}>
        <Breadcrumbs sx={{ mb: 2 }} aria-label="breadcrumb">
          <Link color="primary" onClick={handleBackNavigation}>
            estimates
          </Link>
          <Typography color="text.primary">Estimate Quotation</Typography>
        </Breadcrumbs>
      </div>
    );
  };

  const renderChangeQuantity = () => {
    return (
      <React.Fragment>
        <Dialog
          open={openChangeQty}
          disableEscapeKeyDown
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {selectedIndex + 1}
            {")."} {selectedProduct.title}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Select Quantity
            </DialogContentText>

            <Grid container>
              <Grid item xs={12}>
                <TextField
                  id="name"
                  value={selectedProduct?.quantity}
                  fullWidth
                  type="number"
                  onChange={(e) =>
                    setSelectedProduct((prevData) => ({
                      ...prevData,
                      quantity:
                        parseInt(e.target.value) <= 0
                          ? 1
                          : parseInt(e.target.value),
                      totalPrice:
                        parseFloat(selectedProduct?.unitPrice) *
                        (parseInt(e.target.value) <= 0
                          ? 1
                          : parseInt(e.target.value)) *
                        selectedProduct?.totalPc,
                    }))
                  }
                />
              </Grid>
              <Grid item sx={{ p: 2 }} xs={12}>
                Total Quantity :
                {selectedProduct?.quantity * selectedProduct?.totalPc + " "}
                {selectedProduct?.unit} {"  ,  "} Item Amount:{" "}
                {`₹${selectedProduct?.totalPrice}`}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseChangeQty}>Close</Button>
            <Button
              variant="contained"
              onClick={handleProductChangeQty}
              autoFocus
              disabled={!selectedProduct?.quantity || loading}
            >
              Agree
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  };

  const renderDeleteProduct = () => {
    return (
      <React.Fragment>
        <Dialog
          open={openDeleteProduct}
          disableEscapeKeyDown
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {selectedIndex + 1}
            {")."} {selectedProduct?.title}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete? This action is undone.
              <br />
              <br />
              क्या आप आश्वस्त है कि आपको डिलीट करना है?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDeleteProduct}>CLOSE</Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleDeletionOfProduct}
              autoFocus
            >
              Yes, Delete iT
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  };

  const renderChangeStatusConfirmBox = () => {
    return (
      <React.Fragment>
        <Dialog
          open={openStatusConfirm}
          disableEscapeKeyDown
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {estimate.estimateId}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to change status from{" "}
              <strong>{estimate?.status}</strong> to{" "}
              <strong> {selectedStatus}</strong>? This action cannot be undone.
              <br />
              <br />
              क्या आप वाकई स्थिति बदलना चाहते हैं? -{" "}
              <strong> {selectedStatus}</strong>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseStatusConfirmBox}>CLOSE</Button>
            <Button
              variant="contained"
              color="warning"
              onClick={handleConfirmStatusChange}
              autoFocus
            >
              Yes, Change Status to {selectedStatus}
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  };

  const renderAddProductDailog = () => {
    return (
      <React.Fragment>
        <Dialog
          open={openAddProduct}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          // onClose={handleAddProductClose}
          fullScreen
        >
          <DialogTitle id="alert-dialog-title">Add Product</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Search Product
            </DialogContentText>
            <SearchAutoComplete
              getProductFromAutoComplete={getProductFromAutoComplete}
            />
            <Divider sx={{ mt: 2, mb: 0 }} />
            <ProductSelection
              productId={searchedProduct}
              addProductToCart={addProductToCart}
            />
            <DialogActions>
              <Button
                variant="contained"
                color="warning"
                onClick={handleAddProductClose}
              >
                CLOSE
              </Button>
              {/* <Button
                variant="contained"
                color="primary"
                onClick={handleAddProductClose}
                autoFocus
              >
                Add Product
              </Button> */}
            </DialogActions>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  };
  if (fulloading) {
    return <LineLoading />;
  }
  return vendor ? (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
        }}
      >
        {breadCrums()}
        {openAddProduct && renderAddProductDailog()}
        {openChangeQty && renderChangeQuantity()}
        {openDeleteProduct && renderDeleteProduct()}
        {openStatusConfirm && renderChangeStatusConfirmBox()}
        <Typography variant="body2" gutterBottom>
          To,
        </Typography>
        <Typography variant="h5" gutterBottom>
          {vendor?.name} - ({vendor?.nickName})
        </Typography>

        {/* Accordion for detailed information */}
        <Accordion defaultExpanded={false}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="estimate-details-content"
            id="estimate-details-header"
          >
            <Grid container>
              <Grid item xs={3}>
                <Typography variant="subtitle2">
                  <strong>Estimate No:</strong> {estimate?.estimateId}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="subtitle2">
                  <strong>City:</strong> {vendor?.city}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="subtitle2">
                  <strong>Created Date:</strong>{" "}
                  {formatDateTime(estimate?.createdAt)}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="subtitle2">
                  <strong>Current Status: </strong>{" "}
                  <span style={{ fontWeight: "700", color: "red" }}>
                    {" "}
                    {estimate?.status}{" "}
                  </span>
                </Typography>
              </Grid>
            </Grid>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Typography variant="subtitle2" gutterBottom>
                  <strong> Account ID:</strong> {vendor?.vendorID}
                </Typography>
                <Typography variant="subtitle2" gutterBottom>
                  <strong>Organization Type: </strong> {vendor?.vendorType}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="subtitle2" gutterBottom>
                  <strong> Phone No:</strong> {vendor?.phoneNumber}
                </Typography>
                <Typography variant="subtitle2" gutterBottom>
                  <strong>Email:</strong> {vendor?.email}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="subtitle2" gutterBottom>
                  <strong> Ordered By:</strong> {estimate?.name} (
                  {estimate?.nickName})
                </Typography>
                <Typography variant="subtitle2" gutterBottom>
                  <strong>Orderer's Mobile No.: </strong> {estimate?.phone}
                </Typography>
                <Typography variant="subtitle2" gutterBottom>
                  <strong>Total Qty: </strong> {estimate?.totalQuantity}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" gutterBottom>
                  <strong>Current Status: </strong>{" "}
                  <span style={{ fontWeight: "700", color: "red" }}>
                    {" "}
                    {estimate?.status}{" "}
                  </span>
                </Typography>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        {/* Shipping Address and Delivery Instruction outside accordion */}
        {
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            {estimate?.shippingAddress && (
              <Grid item xs={6}>
                <Typography variant="subtitle2" gutterBottom>
                  <strong>Shipping Address:</strong> {estimate?.shippingAddress}
                </Typography>
              </Grid>
            )}
            {estimate?.deliveryInstruction && (
              <Grid item xs={6}>
                <Typography variant="subtitle2" gutterBottom>
                  <strong>Delivery Instruction: </strong>{" "}
                  {estimate?.deliveryInstruction || "NA"}
                </Typography>
              </Grid>
            )}
          </Grid>
        }
        <Divider sx={{ mt: 2, mb: 2 }} textAlign="left"></Divider>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="flex-end"
        >
          {/* <Grid sx={{ mb: 2 }} item xs={12}>
            <Title>
              <strong> Estimate No:</strong> {estimate?.estimateId}
            </Title>
          </Grid> */}
          <Grid
            sx={{ mb: 2, display: "flex", justifyContent: "space-between" }}
            item
            xs={12}
          >
            <div>
              {estimate?.status === "NEW" && (
                <Button
                  variant="contained"
                  color="warning"
                  size="large"
                  onClick={() => handleStatusChange("INPROGRESS")}
                  sx={{ mr: 1, mb: 1 }}
                >
                  <ChangeCircleIcon sx={{ mr: 1 }} />
                  <strong>CHANGE TO INPROGRESS</strong>
                </Button>
              )}
              {estimate?.status === "INPROGRESS" && (
                <>
                  <Button
                    variant="contained"
                    color="success"
                    size="large"
                    onClick={() => handleStatusChange("COMPLETED")}
                    sx={{ mr: 1, mb: 1 }}
                  >
                    <ChangeCircleIcon sx={{ mr: 1 }} />
                    <strong>CHANGE TO COMPLETED</strong>
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    size="large"
                    onClick={() => handleStatusChange("CANCELLED")}
                    sx={{ mr: 1, mb: 1 }}
                  >
                    <ChangeCircleIcon sx={{ mr: 1 }} />
                    <strong>CHANGE TO CANCELLED</strong>
                  </Button>
                </>
              )}
              {estimate?.status === "CANCELLED" && (
                <Button
                  variant="contained"
                  color="warning"
                  size="large"
                  onClick={() => handleStatusChange("NEW")}
                  sx={{ mr: 1, mb: 1 }}
                >
                  <ChangeCircleIcon sx={{ mr: 1 }} />
                  <strong>CHANGE TO NEW</strong>
                </Button>
              )}
            </div>
            <Button variant="outlined" color="success" onClick={handlePrint}>
              Print Estimate <PictureAsPdfIcon sx={{ ml: 1 }} />
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={(e) => handlePrint(e, true)}
            >
              Print Only Items <InsertDriveFileIcon sx={{ ml: 1 }} />
            </Button>
            {estimate?.status &&
              (estimate.status === "NEW" ||
                estimate.status === "INPROGRESS") && (
                <Button
                  size="large"
                  variant="contained"
                  onClick={() => {
                    setOpenAddProduct(true);
                    setSearchedProduct();
                  }}
                >
                  <strong> ADD PRODUCT {"   "} </strong>
                  <AddToPhotosIcon sx={{ ml: 1 }} />
                </Button>
              )}
          </Grid>
        </Grid>
      </Box>
      <EstimateTable
        cart={estimate?.cart || []}
        totalAmount={estimate?.totalAmount}
        handleDeleteProduct={handleDeleteProduct}
        handleChangeQuantity={handleChangeQuantity}
        isCloned={estimate?.isCloned}
      />
      <Typography variant="subtitle2" gutterBottom>
        <strong>As per customer enquiry. We are sending our quotation.</strong>
      </Typography>
    </>
  ) : null;
}
